import React from 'react';

const Partners = () => {
  const collegePartners = [
    { name: 'VVCE', logo: 'https://linkinprofessionals.com/images/Vidya-Vardhaka-College-of-Engineering-Mysore-1-1-removebg-preview.png' },
    { name: 'JSS College', logo: 'https://linkinprofessionals.com/images/jss-college-logo-removebg-preview-Copy.png' },
    { name: 'MYCEM', logo: 'https://linkinprofessionals.com/images/Mycem-logo-removebg-preview-Copy.png' },
    { name: 'NIE', logo: 'https://linkinprofessionals.com/images/nie-logo-removebg-preview.png' },
    { name: 'College 5', logo: 'https://linkinprofessionals.com/images/dept_logo1650087459.png' },
    { name: 'Vidya Vikas', logo: 'https://linkinprofessionals.com/images/vidya-vikasss-removebg-preview.png' }
  ];

  const corporatePartners = [
    { name: 'LocoNav', logo: 'https://linkinprofessionals.com/images/loconav.png' },
    { name: 'Newgen', logo: 'https://linkinprofessionals.com/images/newgen.png' },
    { name: 'Sagitech', logo: 'https://linkinprofessionals.com/images/sagitech-removebg-preview.png' },
    { name: 'CopyCat', logo: 'https://linkinprofessionals.com/images/copycat-removebg-preview.png' },
    { name: 'Datoms', logo: 'https://linkinprofessionals.com/images/datoms-removebg-preview.png' },
    { name: 'Intellect', logo: 'https://linkinprofessionals.com/images/intellect-removebg-preview.png' }
  ];

  return (
    <section className="py-20 bg-gradient-to-br from-gray-50 to-white" data-testid="partners-section">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
           Our strategic partnership with <span className="bg-gradient-to-r from-blue-600 to-purple-600 bg-clip-text text-transparent"> Amosys Group</span>
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Collaborating with leading institutions and companies to create opportunities
          </p>
        </div>

        {/* College Partners */}
        <div className="mb-16">
          <h3 className="text-2xl font-bold text-gray-900 mb-8 text-center" data-testid="college-partners-title">
            Academic Partners
          </h3>
          <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-8">
            {collegePartners.map((partner, index) => (
              <div
                key={index}
                className="bg-white rounded-xl p-6 shadow-lg hover:shadow-2xl transform hover:-translate-y-2 transition-all duration-300 flex items-center justify-center"
                data-testid={`college-partner-${index}`}
              >
                <img
                  src={partner.logo}
                  alt={partner.name}
                  className="max-h-20 w-auto object-contain hover:scale-110 transition-transform duration-300"
                />
              </div>
            ))}
          </div>
        </div>

        {/* Corporate Partners */}
        <div>
          <h3 className="text-2xl font-bold text-gray-900 mb-8 text-center" data-testid="corporate-partners-title">
            Corporate Partners
          </h3>
          <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-8">
            {corporatePartners.map((partner, index) => (
              <div
                key={index}
                className="bg-white rounded-xl p-6 shadow-lg hover:shadow-2xl transform hover:-translate-y-2 transition-all duration-300 flex items-center justify-center"
                data-testid={`corporate-partner-${index}`}
              >
                <img
                  src={partner.logo}
                  alt={partner.name}
                  className="max-h-20 w-auto object-contain hover:scale-110 transition-transform duration-300"
                />
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Partners;